<p-tree
  [value]="datoteke"
  [layout]="displayType"
  [emptyMessage]="emptyMessage"
  selectionMode="single"
  (onNodeSelect)="nodeSelect($event)"
  (onNodeUnselect)="nodeUnselect($event)"
  [(selection)]="selectedDatoteka"
></p-tree>
